// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spin-animation-26c9f402 {\nto {\n    transform: rotate(360deg);\n}\n}\n.spin[data-v-26c9f402] {\n  animation: spin-animation-26c9f402 2s linear infinite;\n}", ""]);
// Exports
module.exports = exports;
